import { render } from "./breadCrumbs.vue?vue&type=template&id=73344f7c&scoped=true"
import script from "./breadCrumbs.vue?vue&type=script&lang=js"
export * from "./breadCrumbs.vue?vue&type=script&lang=js"

import "./breadCrumbs.vue?vue&type=style&index=0&id=73344f7c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-new-front.rule.vip.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73344f7c"]])

export default __exports__